import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import TeamRightRail from "./TeamRightRail";
import { TEAM_MOBILE_MEDIA_QUERY } from "../utils/teamUiUtils";

/**
 * Envolve páginas do workspace com a barra de navegação (inferior no mobile, direita no desktop).
 */
export default function WorkspaceShell({
  children,
  activeSection,
  basePath = "/equipe",
}) {
  const isMobile = useMediaQuery(TEAM_MOBILE_MEDIA_QUERY);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flex: 1,
        minHeight: 0,
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {children}
      </Box>

      <TeamRightRail
        basePath={basePath}
        activeSection={activeSection}
        isMobile={isMobile}
      />
    </Box>
  );
}
